/* eslint max-nested-callbacks: ["error", 8] */
'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _require = require('streaming-iterables'),
    parallelMap = _require.parallelMap;

var CID = require('cids');

var _require2 = require('../../utils'),
    resolvePath = _require2.resolvePath;

var PinManager = require('./pin-manager');

var PinTypes = PinManager.PinTypes;
var PIN_LS_CONCURRENCY = 8;

module.exports = function (_ref) {
  var pinManager = _ref.pinManager,
      dag = _ref.dag;
  return /*#__PURE__*/function () {
    var _ls = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(paths, options) {
      var type, err, cids, pins, indirects;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = options || {};
              type = PinTypes.all;

              if (paths && paths.type) {
                options = paths;
                paths = null;
              }

              if (!options.type) {
                _context2.next = 9;
                break;
              }

              type = options.type;

              if (typeof options.type === 'string') {
                type = options.type.toLowerCase();
              }

              err = PinManager.checkPinType(type);

              if (!err) {
                _context2.next = 9;
                break;
              }

              throw err;

            case 9:
              if (!paths) {
                _context2.next = 16;
                break;
              }

              paths = Array.isArray(paths) ? paths : [paths]; // check the pinned state of specific hashes

              _context2.next = 13;
              return _awaitAsyncGenerator(resolvePath(dag, paths));

            case 13:
              cids = _context2.sent;
              return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(parallelMap(PIN_LS_CONCURRENCY, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
                  var _yield$pinManager$isP, reason, pinned;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return pinManager.isPinnedWithType(cid, type);

                        case 2:
                          _yield$pinManager$isP = _context.sent;
                          reason = _yield$pinManager$isP.reason;
                          pinned = _yield$pinManager$isP.pinned;

                          if (pinned) {
                            _context.next = 7;
                            break;
                          }

                          throw new Error("path '".concat(paths[cids.indexOf(cid)], "' is not pinned"));

                        case 7:
                          if (!(reason === PinTypes.direct || reason === PinTypes.recursive)) {
                            _context.next = 9;
                            break;
                          }

                          return _context.abrupt("return", {
                            cid: cid,
                            type: reason
                          });

                        case 9:
                          return _context.abrupt("return", {
                            cid: cid,
                            type: "".concat(PinTypes.indirect, " through ").concat(reason)
                          });

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }(), cids)), _awaitAsyncGenerator), "t0", 15);

            case 15:
              return _context2.abrupt("return");

            case 16:
              // show all pinned items of type
              pins = [];

              if (type === PinTypes.direct || type === PinTypes.all) {
                pins = pins.concat(Array.from(pinManager.directPins).map(function (cid) {
                  return {
                    type: PinTypes.direct,
                    cid: new CID(cid)
                  };
                }));
              }

              if (type === PinTypes.recursive || type === PinTypes.all) {
                pins = pins.concat(Array.from(pinManager.recursivePins).map(function (cid) {
                  return {
                    type: PinTypes.recursive,
                    cid: new CID(cid)
                  };
                }));
              }

              if (!(type === PinTypes.indirect || type === PinTypes.all)) {
                _context2.next = 24;
                break;
              }

              _context2.next = 22;
              return _awaitAsyncGenerator(pinManager.getIndirectKeys(options));

            case 22:
              indirects = _context2.sent;
              pins = pins // if something is pinned both directly and indirectly,
              // report the indirect entry
              .filter(function (_ref3) {
                var cid = _ref3.cid;
                return !indirects.includes(cid.toString()) || !pinManager.directPins.has(cid.toString());
              }).concat(indirects.map(function (cid) {
                return {
                  type: PinTypes.indirect,
                  cid: new CID(cid)
                };
              }));

            case 24:
              return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pins), _awaitAsyncGenerator), "t1", 25);

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function ls(_x, _x2) {
      return _ls.apply(this, arguments);
    }

    return ls;
  }();
};